import { gql, useMutation } from "@apollo/client"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material"
import React from "react"

const ADD_TASK = gql`
  mutation MyMutation(
    $user_id: Int!
    $title: String!
    $content: String!
    $check_list: jsonb!
  ) {
    insert_task(
      objects: {
        title: $title
        user_id: $user_id
        content: $content
        check_list: $check_list
      }
    ) {
      returning {
        id
      }
    }
  }
`

export default function AddTask({ open, setOpen, users, current_user_id }) {
  const [formContent, setFormContent] = React.useState({
    user_id: current_user_id,
    title: "",
    content: "",
    check_list: {},
  })
  const [addTask] = useMutation(ADD_TASK)

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
      <DialogTitle>Add Task</DialogTitle>
      <DialogContent>
        <TextField
          style={{ margin: "10px" }}
          value={formContent.title}
          onChange={(e) =>
            setFormContent({ ...formContent, title: e.target.value })
          }
          label="Title"
        />
        <br />
        <TextField
          style={{ margin: "10px" }}
          value={formContent.content}
          onChange={(e) =>
            setFormContent({ ...formContent, content: e.target.value })
          }
          label="Content"
          multiline
          rows={4}
        />
        <br />
        <Select
          style={{ margin: "10px" }}
          label="Assignee"
          value={formContent.user_id}
          onChange={(e) =>
            setFormContent({ ...formContent, user_id: e.target.value })
          }
        >
          {users.map((u) => (
            <MenuItem key={u.id} value={u.id}>
              {u.name}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            addTask({ variables: formContent })
            setOpen(false)
          }}
        >
          Save
        </Button>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}
